const objectUrls = new Set();

export function registerLocalObjectUrl(url) {
  objectUrls.add(url);
}

export function revokeAllLocalObjectUrls() {
  for (const url of objectUrls) {
    URL.revokeObjectURL(url);
  }
  objectUrls.clear();
}
